import {markerFactory} from "@/engine/marker/markerFactory.js";
import {mapContext} from "@/context/global.js";
import {copyToClipboard} from "@/engine/helpers/clipboard.js";
import {toDMS} from "@/engine/helpers/coordinates.js";
import {AMUtil} from "@/engine/leaflet/antimeridianUtils.js";

class gpsMarker {
    constructor(location, map) {
        this.menuItems = {
            CMI_COORDINATES: 1,
            CMI_COORDINATES_DMS: 2,
            CMI_PROPERTIES_SEPARATOR: 3,
            CMI_CREATE_MARKER: 4
        }

        this.map = map
        this.location = null

        this.markerFactory = new markerFactory(map);
        this.marker = this.markerFactory.AddMarker(null, 'sonar', null, 'gpsMarker')
        this.marker.bindTooltip(this._markerText(location), {direction: "top", permanent: true, offset: [0, -40], opacity: 0.7, className: "tooltip-label"}).openTooltip();

        this.marker.menuItem = function (id) {
            return this.options.contextmenuItems.find(function(i){return i.index === id})
        }.bind(this.marker);

        this._createContextMenu(this.marker)

        this.marker.on('click', this._onMarkerClick, this);

        this.marker.setTooltipContent(this.name)
        this.setLocation(location)

    }

    setLocation(location) {
        if (! location.offset && this.marker._map)
            return

        let ll = L.latLng([location.latitude, location.longitude])
        if (AMUtil)
            AMUtil.fixLng(ll)

        this.marker.setLatLng(ll)
        if (!this.marker._map)
            this.marker.addTo(this.map)

        // update marker text if an accuracy is changed
        if ( ! this.location || (this.location.lowAccuracy !== location.lowAccuracy))
            this.marker.setTooltipContent(this._markerText(location))

        // update context menu text (coordinates)
        let i = this.marker.menuItem(this.menuItems.CMI_COORDINATES)
        if (i)
            i.text = "<span class=\"fa fa-crosshairs\"></span>&nbsp;&nbsp;" + ll.lat.toFixed(5) + ',' + ll.lng.toFixed(5);
        i = this.marker.menuItem(this.menuItems.CMI_COORDINATES_DMS)
        if (i)
            i.text = toDMS(ll.lat, ll.lng, 2);

        this.location = location
    }

    _markerText(location) {
        let accuracy = "";

        if (location.lowAccuracy) {
            let radius = Math.floor(location.accuracy);
            accuracy = ' ± ' + this._distanceHuman(radius);
        }

        return "You are here" + accuracy;
    }

    _distanceHuman(distance) {
        let d;
        if (distance === 0)
            return "";
        if (distance < 1000) {
            d = distance + ' meters';
        } else {
            distance = distance / 1000;
            if (distance < 10) {
                distance = distance.toFixed(1);
            } else {
                distance = distance.toFixed(0);
            }
            d = distance + ' km';
        }
        return d;
    }

    remove() {
        this.marker.remove();
    }

    _onMarkerClick(ev) {
        this.marker.fire("contextmenu", ev)
    }

    _createContextMenu(leafletLayer) {
        let ll = leafletLayer;

        let leafletLayerOptions = {
            contextmenu: true,
            contextmenuItems: [],
        };

        if (ll instanceof L.Marker) {
            leafletLayerOptions.contextmenuItems.push({
                // todo coordinates isn't updated on object move
                text: "",
                index: this.menuItems.CMI_COORDINATES,
                callback: function(ev) {
                    if (ll.getLatLng !== undefined) {
                        let msg = ll.getLatLng().lat + ',' + ll.getLatLng().lng
                        copyToClipboard(msg, "COORDINATES");
                    }
                },
            },{
                // todo coordinates isn't updated on object drag
                text: "",
                index: this.menuItems.CMI_COORDINATES_DMS,
                callback: function(ev) {
                    if (ll.getLatLng !== undefined) {
                        let msg = toDMS(ll.getLatLng().lat, ll.getLatLng().lng, 4)
                        copyToClipboard(msg, "COORDINATES");
                    }
                },
            },{
                separator: true,
                index: this.menuItems.CMI_PROPERTIES_SEPARATOR
            }, {
                text: 'Create marker here ...',
                callback: function () {
                    let pos = this.marker.getLatLng()
                    mapContext.createGeometry(L.marker(pos), true)
                }.bind(this),
                index: this.menuItems.CMI_CREATE_MARKER
            })
        }

        ll.bindContextMenu(leafletLayerOptions)
    }
}

export {gpsMarker};
